<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-dark py-5 ps-0 fixed-top" id="navbar">
            <div class="container bg-nav py-2">
                <button class="navbar-toggler px-3 py-3 text-white" data-bs-toggle="modal" data-bs-target="#categorySideBar">
                    <img width="24" src="assets/images/menu.png" alt="">
                </button>
                <div class="d-flex align-content-center">
                    <div class="ps-4 d-block d-lg-none my-auto">
                        <p class="text-md text-white m-0 line-height">222 222 021<img width="20" src="assets/images/call.png" alt=""></p>
                    </div>
                    <a class="pe-2 me-auto" href="#">
                        <img src="assets/images/badoom-03.png" alt="">
                    </a>
                </div>

                <div class="collapse navbar-collapse" id="navbarNav">
                    <ul class="navbar-nav">
                        <template v-for="(item , id) in menu" :key="id">
                            <li class="nav-item">
                                <a class="nav-link active" aria-current="page" :href="item">{{ id }}</a>
                            </li>
                        </template>

                    </ul>
                </div>
                <div class="ps-3 d-none d-lg-block">
                    <p class="text-md text-white ms-auto m-0">2222 222 021   <img width="20" src="assets/images/call.png" alt=""></p>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import {Link} from '@inertiajs/inertia-vue3';
export default {
    components : {Link},
    methods: {
        isUrl(...urls) {
            let currentUrl = this.$page.url.substr(1)
            if (urls[0] === '') {
                return currentUrl === ''
            }
            return urls.filter((url) => currentUrl.startsWith(url)).length
        },
    },
}
</script>

<style scoped>

</style>
